import { render, staticRenderFns } from "./Category1.vue?vue&type=template&id=14819df9&scoped=true"
import script from "./Category1.vue?vue&type=script&lang=js"
export * from "./Category1.vue?vue&type=script&lang=js"
import style0 from "./Category1.vue?vue&type=style&index=0&id=14819df9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14819df9",
  null
  
)

export default component.exports